module.exports = __webpack_public_path__ + "img/golden2.08cccc8c.svg";